import styled from 'styled-components/macro';

import { Button } from '@olist/united';

const ButtonOpenModal = styled(Button)`
  font-size: 14px;
  text-align: left;
`;

export { ButtonOpenModal };
